/**
 * Minimal chain-ID → short name registry for UI display.
 * Not authoritative — callers doing RPC work should use chain-specific libs.
 * Extend as needed; unknown IDs fall back to `Chain #<id>`.
 */
export const CHAIN_REGISTRY: Record<number, { name: string; short: string }> = {
  1: { name: 'Ethereum', short: 'ETH' },
  10: { name: 'Optimism', short: 'OP' },
  56: { name: 'BNB Chain', short: 'BNB' },
  137: { name: 'Polygon', short: 'MATIC' },
  8217: { name: 'Kaia', short: 'KAIA' },
  8453: { name: 'Base', short: 'BASE' },
  42161: { name: 'Arbitrum', short: 'ARB' },
  43114: { name: 'Avalanche', short: 'AVAX' },
  59144: { name: 'Linea', short: 'LINEA' },
  22776: { name: 'MAP Protocol', short: 'MAP' },
  196: { name: 'X Layer', short: 'XLAYER' },
};

export function chainLabel(chainId: number | null | undefined): string {
  if (chainId == null) return 'Unknown';
  return CHAIN_REGISTRY[chainId]?.short ?? `Chain #${chainId}`;
}
